import { UiKitThemeProvider } from 'ui-kit';
import { Router } from '@/Router';
import { GlobalStyles } from '@mui/material';
import { Provider } from 'react-redux';
import { store } from '@/store';
import '@/css/fonts.css';
function App() {
  return (
    <UiKitThemeProvider>
      <GlobalStyles styles={globalStyles} />
      <Provider store={store}>
        <Router />
      </Provider>
    </UiKitThemeProvider>
  );
}

export default App;

const globalStyles = {
  '#root': {
    display: 'flex',
    flexDirection: 'column',
    height: '100vh',
  },
  body: {
    height: '100%',
  },
  html: {
    height: '100%',
  },
};
